$(document).ready(function(){
    $(".mobile-menu").click(function(){
        $(this).toggleClass("is-active");
        $('.js-toggle-mobile').toggleClass("show-menu");
        $('body').toggleClass("no-scroll");
    });
});
